import { styled } from '@material-ui/core/styles';

const FULL_WIDTH = '100% !important';

export const Container = styled('div')(({ theme }) => ({
  height: '65vh',
  maxWidth: 1280,
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.down('1367')]: {
    maxWidth: 1200,
  },
  // [theme.breakpoints.down("lg")]: {
  //   padding: "0 2rem",
  // },
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    minHeight: '100%',
    flexDirection: 'column',
    padding: '1rem 0',
  },
}));

export const Info = styled('div')(({ theme }) => ({
  width: '50%',
  fontSize: '2.0rem',
  fontWeight: 700,
  '& header': {
    width: FULL_WIDTH,
    fontSize: '2rem',
  },
  '& p ': {
    width: FULL_WIDTH,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingBottom: '4rem',
    textAlign: 'center',
    '& p ': {
      width: FULL_WIDTH,
    },
  },
}));

export const Divider = styled('hr')(({ theme }) => ({
  width: '10%',
  margin: '10px 5px',
  border: `1px solid ${theme.palette.primary.main}`,
  [theme.breakpoints.down('sm')]: {
    margin: '20px auto',
  },
}));
